export const BASE_URL = "https://nopser.tutorazzi.com/api/researcher"; 
// export const BASE_URL = "http://127.0.0.1:1180/api/researcher"; 

export const LOGIN_URL = `${BASE_URL}/auth/login`;
export const REGISTER_URL = `${BASE_URL}/auth/register`;

export const GET_APPLICATIONS = `${BASE_URL}/application`;
export const EDIT_APPLICATION = (applicationId) => `${BASE_URL}/application/${applicationId}/edit`;

export const GET_RESEARCHES = `${BASE_URL}/research`;
export const GET_RESEARCHES_DETAIL = (researchId) => `${BASE_URL}/research/${researchId}/show`;
export const CREATE_RESEARCH = `${BASE_URL}/research`;
export const UPDATE_RESEARCH = (researchId) => `${BASE_URL}/research/${researchId}/edit`;
export const DELETE_RESEARCH = (researchId) => `${BASE_URL}/research/${researchId}/close`;

export const GET_DASHBOARD_GRAPH = `${BASE_URL}/dashboard/applications-over-time`;
export const GET_DASHBOARD_TILES = `${BASE_URL}/dashboard/tiles-stats`;

export const GET_PROFILE_URL = `${BASE_URL}/account`;
export const UPDATE_PROFILE_URL = `${BASE_URL}/account/complete`;
export const UPDATE_PROFILE_PIC_URL = `${BASE_URL}/account/profile`;

export const GET_CATEGORIES = `${BASE_URL}/categories`;

export const GET_FORMS = `${BASE_URL}/form`;
export const GET_FORMS_DETAIL = (formId) => `${BASE_URL}/form/${formId}/show`;
export const UPDATE_FORM = (formId) => `${BASE_URL}/form/${formId}/edit`;
export const CREATE_FORMS = `${BASE_URL}/form/add`;

export const ADD_PUSH_NOTIFICATION =   `${BASE_URL}/notification/push`

